import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './Context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

import HeadComponent from './head';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import Home from './components/Home';
import NotFoundPage from './components/NotFoundPage';
import DashboardLayout from './components/Adimn/DashboardLayout';
import Dashboard from './components/Adimn/Dashboard';
import CreateContract from './components/Adimn/Contract/CreateContract';
import ContractList from './components/Adimn/Contract/ContractList';
import ContactManagement from './components/Adimn/Contact/ContactManagement';
import LoginForm from './components/Adimn/LoginForm';
import Logout from './components/Adimn/Logout';
import Blog from './components/Pages/Blog';
import BlogPost from './components/Pages/Blog/BlogPost';
import LatestBlogs from './components/Pages/Blog/latestBlogs';
import Service from './components/Pages/Service';
import BrandingPage from './components/Pages/service/Branding';
import Design from './components/Pages/service/Design';
import VideoProduction from './components/Pages/service/Video-Production';
import DigitalMarketing from './components/Pages/service/Digital-Marketing';
import Connect from './components/Pages/Connect';
import Webs from './components/Pages/service/webs';
import Sidebar from './components/Pages/Sidebar';
import About from './components/Pages/About';
import AIPrompt from './components/Pages/service/AIPrompt';
import FAQPage from './components/Pages/WebDevelopment/faq';
import FAQPopup from './components/Pages/WebDevelopment/FaqPage';
import EventShowcase from './components/Events/Events';
import ChristmasModal from './components/Pages/GiveAway/ChristmasMessage';
import Modal from './components/Modals/Modal';
import AnalyticsDashboard from './components/Pages/AnalyticsDashboard';
import { HelmetProvider } from 'react-helmet-async';
import LiveChatWidget from './components/Events/LiveChatWidget';
import OurStory from './components/Pages/OurStory';
import EncryptionTester from './EncryptionTester';
import LoginPage from './components/Pages/LoginPage';
import ClientDashboard from './components/ClientDashboard/ClientDashboard';
import PrivacyPolicy from './components/Pages/Policy/PrivacyPolicy';
import TermsOfService from './components/Pages/Policy/TermsOfService';
import UsagePolicy from './components/Pages/Policy/UsagePolicy';
import GoogleAuthCallback from './components/Auth/GoogleAuthCallback';
import GoogleAuthProvider from './components/Auth/GoogleAuthProvider';
import SocialMediaContentDashboard from './components/ClientDashboard/content/SocialMediaContentDashboard';
import CommunityTool from './components/ClientDashboard/community/CommunityTool';
import ContentAnalytics from './components/ClientDashboard/content/ContentAnalytics';
import Engagement from './components/ClientDashboard/content/Engagement';
import Campaign from './components/ClientDashboard/content/Campaign';
import Ads from './components/ClientDashboard/content/Ads';
import Reports from './components/ClientDashboard/content/Reports';
import AuthCallback from './components/Pages/AuthCallback';
import Portfolio from './components/Pages/portfolio/Portfolio';
import ProjectStartPage from './components/Pages/Project/ProjectStartPage';

// Protected Route for Admin
const ProtectedRoute = ({ children }) => {
  const { user, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return user ? children : <Navigate to="/" />;
};

// Protected Route for Social Media Dashboard (Google or Local Auth)
const SocialMediaProtectedRoute = ({ children }) => {
  const { user, googleUserInfo, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FD5F20] mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Allow access if user is authenticated via Google OR local login
  const isAuthenticated = user || googleUserInfo;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

// Social Media Dashboard Layout Component
const SocialMediaDashboardLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <HeadComponent
        title="Social Media Dashboard | Ato Creative"
        description="Manage your social media accounts and analytics"
        keywords="social media, dashboard, analytics, content management"
        url="https://atocreative.et/Socialmedia/Dashboard"
        image="https://atocreative.et/logo.png"
        lang="en"
      />
      {children}
    </div>
  );
};

const App = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    setIsModalOpen(true); // auto open on load
  }, []);

  return (
    <HelmetProvider>
      <GoogleAuthProvider>
        <AuthProvider>
          <Router>
            <Routes>
              {/* Community Tool Landing Page */}
              <Route 
                path="/communitytool" 
                element={
                  <div className="flex flex-col min-h-screen bg-grid font-urbanist">
                    <CommunityTool />
                  </div>
                } 
              />

              {/* Social Media Dashboard Routes - Protected */}
              <Route 
                path="/Socialmedia/Dashboard" 
                element={
                  <SocialMediaProtectedRoute>
                    <SocialMediaDashboardLayout>
                      <ClientDashboard />
                    </SocialMediaDashboardLayout>
                  </SocialMediaProtectedRoute>
                } 
              />
              
              <Route 
                path="/Socialmedia/Conent" 
                element={
                  <SocialMediaProtectedRoute>
                    <SocialMediaDashboardLayout>
                      <ContentAnalytics />
                    </SocialMediaDashboardLayout>
                  </SocialMediaProtectedRoute>
                } 
              />
              
              <Route 
                path="/Socialmedia/Engagement" 
                element={
                  <SocialMediaProtectedRoute>
                    <SocialMediaDashboardLayout>
                      <Engagement />
                    </SocialMediaDashboardLayout>
                  </SocialMediaProtectedRoute>
                } 
              />
              
              <Route 
                path="/Socialmedia/Campain" 
                element={
                  <SocialMediaProtectedRoute>
                    <SocialMediaDashboardLayout>
                      <Campaign />
                    </SocialMediaDashboardLayout>
                  </SocialMediaProtectedRoute>
                } 
              />
              
              <Route 
                path="/Socialmedia/Ads" 
                element={
                  <SocialMediaProtectedRoute>
                    <SocialMediaDashboardLayout>
                      <Ads />
                    </SocialMediaDashboardLayout>
                  </SocialMediaProtectedRoute>
                } 
              />
              
              <Route 
                path="/Socialmedia/Reports" 
                element={
                  <SocialMediaProtectedRoute>
                    <SocialMediaDashboardLayout>
                      <Reports />
                    </SocialMediaDashboardLayout>
                  </SocialMediaProtectedRoute>
                } 
              />

              {/* All other routes with standard layout */}
              <Route 
                path="*" 
                element={
                  <div className="flex flex-col min-h-screen overflow-y-hidden">
                    <HeadComponent
                      title="Home | Ato Creative"
                      description="Welcome to Ato Creative, your partner in creative marketing solutions for businesses."
                      keywords="home, creative marketing, businesses, branding, web development"
                      url="https://atocreative.et/"
                      image="https://atocreative.et/logo.png"
                      lang="en"
                    />
                    
                    <div className="flex min-h-full w-full bg-grid font-urbanist">
                      <div className="flex flex-col w-full mx-[5%] md:mx-[10%] lg:mx-[15%] xl:mx-[15%]">
                        <div className="flex-1 ">
                          <Navbar />
                        </div>

                        <div className="flex-1 ">
                          <Routes>
                            <Route path="/auth/callback" element={<AuthCallback />} />

                            <Route path="/" element={<Home />} />
                            <Route path="/Encryption" element={<EncryptionTester />} />
                            <Route path="/login" element={<LoginForm />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/About Us" element={<About />} />
                            <Route path="/ourStory" element={<OurStory />} />
                            <Route path="/ai-prompt" element={<AIPrompt />} />
                            <Route path="/blogpost" element={<BlogPost />} />
                            <Route path="/Blog/LatestBlogs" element={<LatestBlogs />} />
                            <Route path="/service" element={<Service />} />
                            <Route path="/service/branding" element={<BrandingPage />} />
                            <Route path="/service/design" element={<Design />} />
                            <Route path="/service/digital-marketing" element={<DigitalMarketing />} />
                            <Route path="/service/video-production" element={<VideoProduction />} />
                            <Route path="/logout" element={<Logout />} />
                            <Route path="/loginPage" element={<LoginPage />} />
                            <Route path="/connect" element={<Connect />} />
                            <Route path="/FAQ" element={<FAQPage />} />
                            <Route path="/EventShowcase" element={<EventShowcase />} />
                            <Route path="/Policy/PrivacyPolicy" element={<PrivacyPolicy />} />
                            <Route path="/Policy/TermsOfService" element={<TermsOfService />} />
                            <Route path="/Policy/UsagePolicy" element={<UsagePolicy />} />
                            <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
                            <Route path="/atocreative/portfolio" element={<Portfolio />} />
                            <Route path="/atocreative/Project" element={<ProjectStartPage />} />

                            {/* Protected Admin Routes */}
                            <Route
                              path="/admin/*"
                              element={
                                <ProtectedRoute>
                                  <DashboardLayout />
                                </ProtectedRoute>
                              }
                            >
                              <Route path="dashboard" element={<Dashboard />} />
                              <Route path="contract/create-contract" element={<CreateContract />} />
                              <Route path="contract/contracts" element={<ContractList />} />
                              <Route path="contact/contact-management" element={<ContactManagement />} />
                            </Route>

                            <Route path="*" element={<NotFoundPage />} />
                          </Routes>
                        </div>
                      </div>
                    </div>
                    
                    <Footer />
                    <BackToTop />
                  </div>
                } 
              />
            </Routes>
          </Router>
        </AuthProvider>
      </GoogleAuthProvider>
    </HelmetProvider>
  );
};

export default App;